module.exports = __webpack_public_path__ + "static/screenshot-3-346dcb9d3d50f331f2a6488ddf02cc6f.png";